import { Bell, CheckCircle, Mail, Loader2 } from "lucide-react";

export function AlertSubscribeSection({ politician, alertEmail, setAlertEmail, alertStatus, alertSubscribing, subscribeAlert, isDark }) {
  const text = isDark ? "#F8FAFC" : "#0F172A";
  const textSec = isDark ? "#94A3B8" : "#475569";
  return (
    <div className="max-w-4xl mx-auto px-4 mb-10">
      <div
        className="border-2 border-black p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4"
        style={{ backgroundColor: isDark ? "#1E293B" : "#EFF6FF", boxShadow: "3px 3px 0 #000" }}
        data-testid="alert-subscription-section"
      >
        <div className="flex items-center gap-3 flex-shrink-0">
          <div className="w-10 h-10 flex items-center justify-center border-2 border-black" style={{ backgroundColor: "#2E5948" }}>
            <Bell className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="font-black text-sm" style={{ color: text }}>Get Alerts for {politician?.name}</p>
            <p className="text-xs" style={{ color: textSec }}>Email when they vote on a new bill or their promises change status</p>
          </div>
        </div>
        {alertStatus === "subscribed" ? (
          <div className="flex items-center gap-2 ml-auto text-sm font-black" style={{ color: "#10B981" }}>
            <CheckCircle className="w-4 h-4" /> You're subscribed — we'll alert you when things change.
          </div>
        ) : (
          <div className="flex flex-1 gap-2 items-center ml-auto">
            <input
              type="email"
              value={alertEmail}
              onChange={(e) => setAlertEmail(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && subscribeAlert()}
              placeholder="your@email.com"
              className="flex-1 px-3 py-2 text-xs border-2 border-black font-medium focus:outline-none"
              style={{ backgroundColor: isDark ? "#0F172A" : "#fff", color: text }}
              data-testid="alert-email-input"
            />
            <button
              onClick={subscribeAlert}
              disabled={alertSubscribing}
              className="flex items-center gap-1.5 px-4 py-2 border-2 border-black text-xs font-black hover:-translate-y-0.5 transition-transform disabled:opacity-60 whitespace-nowrap"
              style={{ backgroundColor: "#2E5948", color: "#fff", boxShadow: "2px 2px 0 #000" }}
              data-testid="alert-subscribe-btn"
            >
              {alertSubscribing ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Mail className="w-3.5 h-3.5" />}
              Alert Me
            </button>
          </div>
        )}
        {alertStatus && alertStatus !== "subscribed" && (
          <p className="text-xs mt-1 w-full" style={{ color: "#EF4444" }}>{alertStatus}</p>
        )}
      </div>
    </div>
  );
}
